import { atom } from 'recoil';

import { UserPermissions } from '@enums/user-permissions';

import { Atoms } from '../constants';

export const userPermissionsAtom = atom<UserPermissions[]>({
  key: Atoms.userPermissions,
  default: [],
});

export const isSubscriptionAdminAtom = atom<boolean>({
  key: Atoms.isSubscriptionAdmin,
  default: false,
});
